/* Attuned site chrome behaviour: header tone on scroll, menu panels, search, phone menu, cart drawer lock, footer signup. */
(function () {
  var top = document.querySelector('[data-ahc-top]');
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var body = document.body;
  var drawerOpen = false, menuOpen = false;

  // page lock while the cart drawer or phone menu is open. html.ahc-locked (the theme scrolls on html) covers wheel and keys; on touch
  // (iOS ignores overflow), a move only goes through inside the open layer, in a panel that can still scroll that way. The page never
  // moves, so the sticky header stays put and the scroll position is simply where it was (the fixed-body trick would drop the header off the top).
  var layers = '#cart-drawer, [data-ahc-pmenu]', lastY = 0;
  var setLock = function () {
    var on = drawerOpen || menuOpen;
    document.documentElement.classList.toggle('ahc-locked', on);
    body.classList.toggle('ahc-lock', on);
  };
  var canScroll = function (el, dy) {
    for (; el && el.nodeType === 1; el = el.parentElement) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1)
        return dy > 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1;
      if (el.matches(layers)) return false;
    }
    return false;
  };
  document.addEventListener('touchstart', function (e) { if (e.touches.length === 1) lastY = e.touches[0].clientY; }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!(drawerOpen || menuOpen) || e.touches.length > 1) return;
    var y = e.touches[0].clientY, dy = y - lastY; lastY = y;
    var t = e.target.nodeType === 1 ? e.target : e.target.parentElement;
    if (e.cancelable && (!t || !t.closest(layers) || (dy && !canScroll(t, dy)))) e.preventDefault();
  }, { passive: false });

  if (top) {
    var scrim = document.querySelector('[data-ahc-scrim]');
    var light = top.dataset.tone === 'light';
    // header: transparent at the top, frosted paper once you scroll (past the photo on the homepage). It never hides.
    var frost = function () {
      var y = window.pageYOffset || 0;
      var at = light ? Math.max(120, window.innerHeight * 0.75) : 8;
      top.classList.toggle('is-frost', y > at);
    };
    window.addEventListener('scroll', frost, { passive: true });
    frost();

    // desktop panels: unfold under the header, swap without closing, wait a beat before closing
    var openP = null, tOpen, tClose;
    var panel = function (n) { return top.querySelector('[data-ahc-panel="' + n + '"]'); };
    var close = function () {
      clearTimeout(tOpen);
      $$('[data-ahc-panel]', top).forEach(function (p) { p.classList.remove('show', 'quick'); });
      $$('[data-ahc-nav]', top).forEach(function (a) { a.classList.remove('on'); });
      if (scrim) scrim.classList.remove('show');
      top.classList.remove('is-open');
      openP = null;
    };
    var closeSoon = function () { clearTimeout(tClose); tClose = setTimeout(close, 220); };
    var open = function (n, a) {
      clearTimeout(tClose);
      if (openP === n) return;
      var p = panel(n); if (!p) return;
      var switching = !!openP;
      $$('[data-ahc-panel]', top).forEach(function (x) { if (x !== p) { x.classList.add('quick'); x.classList.remove('show'); } });
      $$('[data-ahc-nav]', top).forEach(function (x) { x.classList.remove('on'); });
      p.classList.toggle('quick', switching);
      openP = n;
      p.classList.add('show'); top.classList.add('is-open'); a.classList.add('on');
      if (scrim) scrim.classList.add('show');
      if (n === 'search') { var q = p.querySelector('[data-ahc-q]'); if (q) setTimeout(function () { q.focus(); }, 60); }
    };
    $$('[data-ahc-nav]', top).forEach(function (a) {
      var n = a.dataset.ahcNav;
      if (n === 'search') {
        a.addEventListener('click', function (e) { e.preventDefault(); openP === 'search' ? close() : open(n, a); });
        return;
      }
      a.addEventListener('mouseenter', function () { clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(function () { open(n, a); }, openP ? 0 : 90); });
      a.addEventListener('mouseleave', function () { clearTimeout(tOpen); if (openP && openP !== 'search') closeSoon(); });
      a.addEventListener('focus', function () { open(n, a); });
    });
    $$('[data-ahc-panel]', top).forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(tClose); });
      p.addEventListener('mouseleave', function () { if (openP !== 'search') closeSoon(); });
    });
    if (scrim) { scrim.addEventListener('mouseenter', function () { if (openP !== 'search') closeSoon(); }); scrim.addEventListener('click', close); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); setMenu(false); } });

    // predictive search (Shopify suggest endpoint). Remedy prices only for signed-in visitors, like the remedy pages.
    var q = top.querySelector('[data-ahc-q]'), out = top.querySelector('[data-ahc-sres]'), tq, seq = 0;
    var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var money = function (v) { var n = parseFloat(v); if (isNaN(n)) return ''; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); };
    if (q && out) q.addEventListener('input', function () {
      clearTimeout(tq);
      var term = q.value.trim();
      if (term.length < 2) { out.innerHTML = ''; return; }
      tq = setTimeout(function () {
        var my = ++seq;
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); }).then(function (d) {
            if (my !== seq) return;
            var R = (d.resources && d.resources.results) || {}, rows = [];
            var words = term.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
            var hit = function (t) { t = (t || '').toLowerCase(); return words.some(function (w) { return t.indexOf(w) > -1; }); };
            // the three scans are matched here first: Shopify's suggestions don't always return them
            var scans = (window.ahcScans || []).filter(function (s) { return hit(s.t + ' scan'); });
            scans.forEach(function (s) { rows.push('<a href="' + esc(s.u) + '"><span class="t">' + (s.i ? '<img src="' + esc(s.i) + '" alt="">' : '') + '</span><span>' + esc(s.t) + '</span><span class="muted">' + esc(s.p) + '</span></a>'); });
            (R.products || []).filter(function (p) { return hit(p.title + ' ' + p.type) && !/scan/i.test(p.type || ''); }).slice(0, 4 - Math.min(scans.length, 2)).forEach(function (p) {
              var scan = /scan/i.test(p.type || '');
              var price = scan || window.ahcCustomer ? money(p.price) : (/remedy/i.test(p.type || '') ? 'Remedy' : money(p.price));
              rows.push('<a href="' + esc(p.url) + '"><span class="t">' + (p.image ? '<img src="' + esc(p.image) + '&width=120" alt="">' : '') + '</span><span>' + esc(p.title) + '</span><span class="muted">' + esc(price) + '</span></a>');
            });
            (R.articles || []).filter(function (a) { return hit(a.title); }).slice(0, 2).forEach(function (a) {
              rows.push('<a href="' + esc(a.url) + '"><span class="t"></span><span>' + esc(a.title) + '</span><span class="muted">Journal</span></a>');
            });
            (R.pages || []).filter(function (a) { return hit(a.title) && !/\/pages\/(lp-|wellness|endurance|supplement|view-results|scan-result|llms|beta-|login|register)/.test(a.url || ''); }).slice(0, 2).forEach(function (a) {
              rows.push('<a href="' + esc(a.url) + '"><span class="t"></span><span>' + esc(a.title) + '</span><span class="muted">Page</span></a>');
            });
            out.innerHTML = (rows.length ? rows.join('') : '<p class="none">Nothing matched yet. Press Enter to search everything.</p>')
              + '<a class="all" href="/search?q=' + encodeURIComponent(term) + '&options[prefix]=last"><span class="ul">See all results for “' + esc(term) + '”</span><span>&rarr;</span></a>';
          }).catch(function (err) { if (window.console) console.warn('ahc search', err); });
      }, 180);
    });

    // phone menu: unfolds, burger folds into an X, sections open in place
    var pm = top.querySelector('[data-ahc-pmenu]'), burger = top.querySelector('[data-ahc-burger]');
    var setMenu = function (on) {
      if (!pm) return;
      pm.classList.toggle('show', on);
      top.classList.toggle('is-open', on);
      menuOpen = on; setLock();
      if (burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      pm.style.top = top.getBoundingClientRect().bottom + 'px';
    };
    if (burger) burger.addEventListener('click', function () { setMenu(!pm.classList.contains('show')); });
    // the phone menu hides itself from 1024px up, so the lock goes with it
    window.addEventListener('resize', function () { if (menuOpen && window.innerWidth >= 1024) setMenu(false); });
    // a link to the page you're on just closes the menu, so you stay where you were instead of reloading at the top
    if (pm) pm.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
      var u = new URL(a.href, location.href);
      if (u.origin === location.origin && u.pathname === location.pathname && !u.hash && (!u.search || u.search === location.search)) { e.preventDefault(); setMenu(false); }
    });
    // back to a page that was left with the menu open: it comes back closed and unlocked
    window.addEventListener('pageshow', function (e) { if (e.persisted && menuOpen) setMenu(false); });
    $$('[data-ahc-acc]', pm || document).forEach(function (b) {
      b.addEventListener('click', function () {
        var it = b.parentElement, on = !it.classList.contains('on');
        $$('.it', pm).forEach(function (x) { x.classList.remove('on'); });
        it.classList.toggle('on', on); pm.classList.toggle('has-open', on);
      });
    });
  }

  // cart drawer: the page locks and the chat bubble steps aside while it is open, menus close when it opens.
  // Every close path (Close, backdrop, Escape, a script calling hide) ends in Bootstrap's hidden event, which releases the lock.
  document.addEventListener('show.bs.offcanvas', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    drawerOpen = true;
    if (top) { $$('[data-ahc-panel]', top).forEach(function (p) { p.classList.remove('show'); }); top.classList.remove('is-open'); }
    var s = document.querySelector('[data-ahc-scrim]'); if (s) s.classList.remove('show');
    var pmm = document.querySelector('[data-ahc-pmenu]'); if (pmm && pmm.classList.contains('show')) { pmm.classList.remove('show'); menuOpen = false; }
    setLock();
  });
  document.addEventListener('hidden.bs.offcanvas', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    drawerOpen = false; setLock();
  });

  // cart drawer, empty state: Add buttons put a scan in the cart and reload the drawer
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ahc-add]');
    if (!b) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.ahcAdd), quantity: 1 }] }) })
      .then(function () { if (window.loadEgCartDrawer) window.loadEgCartDrawer(); })
      .catch(function () { b.removeAttribute('aria-busy'); });
  });

  // panel and phone-menu photos: fetch them once the page has settled, so menus open with their pictures ready
  var warm = function () { $$('.ahc-panel img, .ahc-pmenu img').forEach(function (i) { i.loading = 'eager'; }); };
  if (document.readyState === 'complete') setTimeout(warm, 1200); else window.addEventListener('load', function () { setTimeout(warm, 1200); });

  // footer signup -> Klaviyo list (client subscriptions API, public key only). Delegated: this script loads async.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ahc-signup]');
    if (!f) return;
    {
      e.preventDefault();
      var email = f.querySelector('input[type=email]'), msg = f.parentElement.querySelector('[data-ahc-msg]');
      if (!email || !email.value || !/.+@.+\..+/.test(email.value)) { if (msg) msg.textContent = 'Please enter a valid email address.'; return; }
      var bodyJ = { data: { type: 'subscription', attributes: { custom_source: 'Site footer', profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } } }, relationships: { list: { data: { type: 'list', id: f.dataset.list } } } } };
      f.classList.add('busy');
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(f.dataset.key), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(bodyJ) })
        .then(function (r) {
          f.classList.remove('busy');
          if (r.status === 202 || r.ok) { f.reset(); if (msg) msg.textContent = 'You’re in. Thank you.'; if (window.ahTrack) window.ahTrack('newsletter_signup', { label: 'footer' }); }
          else if (msg) msg.textContent = 'That didn’t go through. Please try again.';
        }).catch(function () { f.classList.remove('busy'); if (msg) msg.textContent = 'That didn’t go through. Please try again.'; });
    }
  });

  // footer accessibility button opens the accessibility widget (its floating button stays hidden)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ahc-a11y]');
    if (!b) return;
    e.preventDefault();
    if (window.interdeal && window.interdeal.a11y && window.interdeal.a11y.openMenu) window.interdeal.a11y.openMenu();
  });
})();
